import { headingLevels, Title } from './Title';

export interface Headings {
    headingLevel: headingLevels;
    headerText?: string;
    headingNumber?: number;
    markerLabel?: string;
    disableTabStaticData?: boolean;
}

export interface HeaderProps {
    headings?: Headings[];
    typographyClass?: string;
    disableTabStaticData?: boolean;
}

function Header(props: Headings) {
    const { headerText, headingLevel, headingNumber, disableTabStaticData } = props;

    return (
        <>
            {headerText && (
                <Title
                    level={headingLevel}
                    headingNumber={headingNumber}
                    disableTabStaticData={disableTabStaticData}
                >
                    {headerText}
                </Title>
            )}
        </>
    );
}

export default Header;
